import { useQuery } from '@tanstack/react-query';

import { api } from '@/api/client';
import type { ReadinessResponse } from '@/types/api';

export async function fetchReadiness(): Promise<ReadinessResponse> {
  const { data } = await api.get<ReadinessResponse>('/health/ready');
  return data;
}

export function useReadiness() {
  return useQuery({
    queryKey: ['health', 'ready'],
    queryFn: fetchReadiness,
    refetchInterval: 10_000,
    // A failing readiness check is the answer, not an error to retry away.
    retry: false,
  });
}
